import styles from "./HomePage.module.scss";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/ui/CustomButton/CustomButton";

import sendWhite from "../../assets/images/icons/send-white.svg";
import whyKoin from "../../assets/images/home/why-join.png";
import noUpfortCost from "../../assets/images/home/no-upfort-cost.svg";
import increasedVisibility from "../../assets/images/home/increased-visibility.svg";
import smartScheduling from "../../assets/images/home/smart-scheduling.svg";
import exclusivePerks from "../../assets/images/home/exclusive-perks.svg";
import searchGrey from "../../assets/images/icons/search-grey.svg";
import linkIcon from "../../assets/images/icons/link.svg";
import starsIcon from "../../assets/images/icons/stars.svg";
import { useState } from "react";
import ComingSoonPopup from "../../components/ComingSoonPopup/ComingSoonPopup";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { textCropping } from "../../helper/language";
import { environment } from "../../environment";

const HomePage = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [showComingSoonPopup, setShowComingSoonPopup] = useState<boolean>(false);

  const activeLanguage = i18n.language as "en" | "gr";

  const redirectToCalendly = () => {
    window.open("https://calendly.com/clubpass/30min", "_blank");
  };

  const renderArticleText = (text: string) => {
    return text.length > 52 ? text.slice(0, 52) + "..." : text;
  };

  return (
    <>
      <Helmet>
        <title>{t("GymPass24HourFitnessPass")}</title>
        <meta name="description" content={t("LookingForFlexibleFitnessOptions")} />
        <meta
          name="keywords"
          content="Gym Pass, 24 Hour Fitness Pass, Wellness Center Guest Pass"
        />
      </Helmet>
      <div className={styles.page}>
        {/*Hero section*/}
        <section className={styles.hero}>
          <div className={`${styles.heroWrapper} container`}>
            <h1>{t("YourAllAccessPassToFitnessWellnessMore")}</h1>
            <p>{t("BookUnlimitedGymSessionsFitnessClassesAndWellnessTreatmentsWithASinglePass")}</p>
            <div className={styles.btnWrapper}>
              {/*<CustomButton*/}
              {/*  text={t("StartYourFreeTrial")}*/}
              {/*  type={"button"}*/}
              {/*  typeStyle={"fill"}*/}
              {/*  style={{*/}
              {/*    background: "#FFF",*/}
              {/*    color: "#000",*/}
              {/*  }}*/}
              {/*/>*/}
              <CustomButton
                functionOnClick={redirectToCalendly}
                text={t("ListYourBusinessForFree")}
                type={"button"}
                typeStyle={"outline"}
                icon={sendWhite}
                altIcon={"List"}
                style={{
                  background: "transparent",
                  color: "#FFF",
                  borderColor: "#FFF",
                  display: "inline-flex",
                  width: "unset",
                }}
              />
            </div>
          </div>
        </section>

        {/* Why join */}
        <section className={`${styles.why} container`}>
          <div className={styles.info}>
            <h2 className={styles.title}>{t("WhyJoinClubPass")}</h2>
            <p className={styles.subtitle}>
              {t("ASmarterWayToBookYourWorkoutsAndWellnessTreatmentsAllInOnePlace")}
            </p>
            <CustomButton
              functionOnClick={redirectToCalendly}
              text={t("StartExploring")}
              type={"button"}
              typeStyle={"fill"}
              style={{ maxWidth: "280px" }}
            />
          </div>
          <img className={styles.image} src={whyKoin} alt={"Why Join?"} />
        </section>

        {/* Boost bookings */}
        <section className={`${styles.boost}`}>
          <div className={"container"}>
            <div className={styles.topWrapper}>
              <h2 className={styles.title}>{t("BoostYourBookingsListYourBusinessForFree")}</h2>
              <p className={styles.subtitle}>
                {t("JoinTheFastestGrowingFitnessWellnessNetworkInGreece")}
              </p>
              <CustomButton
                functionOnClick={redirectToCalendly}
                text={t("ListYourBusinessNow")}
                type={"button"}
                typeStyle={"fill"}
                style={{
                  display: "inline-flex",
                  width: "unset",
                }}
              />
            </div>

            <div className={styles.mainWrapper}>
              <div className={styles.item}>
                <img src={noUpfortCost} alt={t("NoUpfrontCost")} />
                <h3>{t("NoUpfrontCost")}</h3>
                <p>{t("GetListedFreePayOnlyPerBooking")}</p>
              </div>

              <div className={styles.item}>
                <img src={increasedVisibility} alt={t("IncreasedVisibility")} />
                <h3>{t("IncreasedVisibility")}</h3>
                <p>{t("ReachThousandsOfFitnessWellnessSeekers")}</p>
              </div>

              <div className={styles.item}>
                <img src={smartScheduling} alt={t("SmartScheduling")} />
                <h3>{t("SmartScheduling")}</h3>
                <p>{t("ManageYourAvailabilityAndBookingsEasily")}</p>
              </div>

              <div className={styles.item}>
                <img src={exclusivePerks} alt={t("ExclusivePerks")} />
                <h3>{t("ExclusivePerks")}</h3>
                <p className={styles.dot}>{t("OffGymEquipmentForClubPassPartners")}</p>
                <p className={styles.dot}>{t("OffTrainYourPulseCRMForManagingMemberships")}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Find class */}
        <section className={styles.find}>
          <div className={`${styles.findContainer} container`}>
            <h2 className={styles.title}>{t("FindAClassBookInSeconds")}</h2>
            <p className={styles.subtitle}>
              {t("ExploreThousandsOfFitnessClassesWellnessTreatments")}
            </p>
            <div className={styles.customInput}>
              <div>
                <img src={searchGrey} alt={"Search"} />
                <input />
              </div>
              <CustomButton
                functionOnClick={() => setShowComingSoonPopup(true)}
                text={t("FindClasses")}
                type={"button"}
                typeStyle={"fill"}
                style={{ display: "inline-flex" }}
              />
            </div>
          </div>
        </section>

        {/* Articles */}
        <section className={`${styles.articles} container`}>
          <h2 className={styles.title}>{t("ExpertAdviceIndustryInsights")}</h2>
          <p className={styles.subtitle}>{t("ReadExpertFitnessTipsWellnessGuides")}</p>
          <div className={styles.wrapper}>
            <div className={styles.item}>
              <img
                className={styles.articleImg}
                src={`${environment.serverPath}/public/images/blog/article-01.png`}
                alt={"Article01"}
              />
              <h3>{textCropping(t("IntroducingClubpassGreeceNewWayToDiscoverGymsSalons"), 55)}</h3>
              <p>
                {textCropping(t("DiscoverClubpassTheDigitalPlatformThatLetsYouBookDayPasses"), 112)}
              </p>
              <Link
                target={"_blank"}
                to={
                  activeLanguage === "en"
                    ? "/blog/introducing-clubpass-greece-gyms-salons"
                    : "/blog/sas-parousiazoume-to-clubpass-gymnastiria-salonia-ellada"
                }
              >
                {t("ContinueReading")} <img src={linkIcon} alt={"Link"} />
              </Link>
            </div>

            <div className={styles.item}>
              <img
                className={styles.articleImg}
                src={`${environment.serverPath}/public/images/blog/article-02.png`}
                alt={"Article02"}
              />
              <h3>{textCropping(t("TiredOfExpensiveMembershipsTryAGymForADayInYourArea"), 55)}</h3>
              <p>{textCropping(t("ExploreAffordableGymDayPassesWithClubPassNoContracts"), 110)}</p>
              <Link
                target={"_blank"}
                to={
                  activeLanguage === "en"
                    ? "/blog/gym-day-pass-vs-membership-benefits"
                    : "/blog/gymnastirio-day-pass-vs-syndromi-ofeli"
                }
              >
                {t("ContinueReading")} <img src={linkIcon} alt={"Link"} />
              </Link>
            </div>

            <div className={styles.item}>
              <img
                className={styles.articleImg}
                src={`${environment.serverPath}/public/images/blog/article-03.png`}
                alt={"Article03"}
              />
              <h3>{textCropping(t("HowGymsAndSalonsInGreeceCanGetMoreClientsForFree"), 54)}</h3>
              <p>{textCropping(t("DiscoverHowGymsSalonsAndWellnessCentersInGreeceCanGet"), 110)}</p>
              <Link
                target={"_blank"}
                to={
                  activeLanguage === "en"
                    ? "/blog/how-gyms-and-salons-in-greece-can-get-free-clients"
                    : "/blog/pos-na-vreis-neous-pelates-dorean-gymnastirio-salon-ellada"
                }
              >
                {t("ContinueReading")} <img src={linkIcon} alt={"Link"} />
              </Link>
            </div>
          </div>
          <div className={"flex-just-center"}>
            <CustomButton
              text={t("ExploreMore")}
              type={"button"}
              typeStyle={"fill"}
              style={{
                display: "inline-flex",
                width: "unset",
              }}
              functionOnClick={() => navigate("/blog")}
            />
          </div>
        </section>

        {/* Testimonials */}
        <section className={`${styles.testimonials} container`}>
          <h3 className={styles.title}>{t("SuccessStoriesFromOurUsersPartners")}</h3>
          <div className={styles.wrapper}>
            <div className={styles.item}>
              <img src={starsIcon} alt={"Stars"} />
              <p>{t("ClubPassBroughtMeMoreBookings")}</p>
              <p className={styles.name}>
                {"Nikos from Athens"} <span>{t("GymOwner")}</span>
              </p>
            </div>

            <div className={styles.item}>
              <img src={starsIcon} alt={"Stars"} />
              <p>{t("ICanTryMultipleGymsWithoutSeparateSubscriptions")}</p>
              <p className={styles.name}>
                {"Maria from Thessaloniki"} <span>{t("Customer")}</span>
              </p>
            </div>

            <div className={styles.item}>
              <img src={starsIcon} alt={"Stars"} />
              <p>{t("FreeListingOnClubPassDoubledMyAppointments")}</p>
              <p className={styles.name}>
                {"Evgenia from Crete"} <span>{t("WellnessStudio")}</span>
              </p>
            </div>
          </div>
          <div className={"flex-just-center"}>
            <CustomButton
              functionOnClick={redirectToCalendly}
              text={t("JoinTheClubPassCommunity")}
              type={"button"}
              typeStyle={"fill"}
              style={{
                display: "inline-flex",
                width: "unset",
              }}
            />
          </div>
        </section>

        {/* Ready to join */}
        <section className={`${styles.ready} container`}>
          <div className={styles.box}>
            <h3>{t("ReadyJoinGetStartedNow")}</h3>
            <div className={styles.btnWrapper}>
              {/*<CustomButton*/}
              {/*  text={t("StartYourFreeTrial")}*/}
              {/*  type={"button"}*/}
              {/*  typeStyle={"fill"}*/}
              {/*  style={{*/}
              {/*    background: "#FFF",*/}
              {/*    color: "#000",*/}
              {/*  }}*/}
              {/*/>*/}
              <CustomButton
                functionOnClick={redirectToCalendly}
                text={t("ListYourBusinessForFree")}
                type={"button"}
                typeStyle={"outline"}
                icon={sendWhite}
                altIcon={"List"}
                style={{
                  background: "transparent",
                  color: "#FFF",
                  borderColor: "#FFF",
                  display: "inline-flex",
                  width: "unset",
                }}
              />
            </div>
          </div>
        </section>

        {showComingSoonPopup && <ComingSoonPopup close={() => setShowComingSoonPopup(false)} />}
      </div>
    </>
  );
};

export default HomePage;
